import adapty from '@/shared/assets/platforms/adapty.png'
import adjust from '@/shared/assets/platforms/adjust.png'
import akakce from '@/shared/assets/platforms/akakce-mini.png'
import appSamurai from '@/shared/assets/platforms/app-samurai.svg'
import appStore from '@/shared/assets/platforms/app-store.png'
import appleSearchAds from '@/shared/assets/platforms/apple.svg'
import applovinMax from '@/shared/assets/platforms/applovin-max.svg'
import appsflyer from '@/shared/assets/platforms/appsflyer.png'
import bigquery from '@/shared/assets/platforms/big-query.png'
import bingAds from '@/shared/assets/platforms/bing.png'
import cm360 from '@/shared/assets/platforms/cm360.png'
import cimri from '@/shared/assets/platforms/cimri.png'
import criteo from '@/shared/assets/platforms/criteo.png'
import dv360 from '@/shared/assets/platforms/dv360.png'
import gelirOrtaklari from '@/shared/assets/platforms/gelir-ortaklari.png'
import googleAds from '@/shared/assets/platforms/google-ads.png'
import googleAnalytics from '@/shared/assets/platforms/google-analytics.png'
import hardal from '@/shared/assets/platforms/hardal.png'
import hopi from '@/shared/assets/platforms/hopi.png'
import ikas from '@/shared/assets/platforms/ikas.png'
import linkedin from '@/shared/assets/platforms/linkedin.webp'
import merchantCenter from '@/shared/assets/platforms/merchant-center.svg'
import metaAds from '@/shared/assets/platforms/meta.png'
import microsoftStore from '@/shared/assets/platforms/microsoft-store.png'
import openaiAds from '@/shared/assets/platforms/openai-ads.svg'
import pinterest from '@/shared/assets/platforms/pinterest.png'
import playStore from '@/shared/assets/platforms/play-store.webp'
import reddit from '@/shared/assets/platforms/reddit.png'
import reklamstore from '@/shared/assets/platforms/reklamstore.png'
import revenuecat from '@/shared/assets/platforms/revenuecat_short_logo.png'
import rtbHouse from '@/shared/assets/platforms/rtb-mini.svg'
import googleSearchConsole from '@/shared/assets/platforms/search-console.svg'
import googleSheets from '@/shared/assets/platforms/sheet-icon.png'
import shopify from '@/shared/assets/platforms/shopify.png'
import singular from '@/shared/assets/platforms/singular.png'
import tagManager from '@/shared/assets/platforms/tag-manager.svg'
import snapchatAds from '@/shared/assets/platforms/snapchat.png'
import ticimax from '@/shared/assets/platforms/ticimax.png'
import tiktokAds from '@/shared/assets/platforms/tiktok-1.png'
import tsoft from '@/shared/assets/platforms/tsoft.png'
import twitter from '@/shared/assets/platforms/x.png'
import yandex from '@/shared/assets/platforms/yandex.png'
import yango from '@/shared/assets/platforms/yango_ads.png'
import youtube from '@/shared/assets/platforms/youtube.png'

// Exact legacy Data Connectors asset: app.orphex.co/assets/sheet_icon.DaaqnZpK.png.
// SHA-256: 39eff4da643cdd930111d82d9ef9b259f7083aef7e505fd729c3a409e1211bae

// The mcp.orphex.co Singular mark (ORP-25427), byte for byte: www.singular.net's own
// apple-touch-icon. SHA-256: 0cb60a635c26389270a2238fb2b94dc339257ac38763fef34378e4a0bbc6a910

// The key space is module 12's provider registry `logo` field (`features/integrations/models`).
// Until this map covered them, 23 of its 37 keys fell through to `PlatformLogo`'s question-mark
// fallback — every connector outside the big-five ad platforms rendered as a placeholder, which is
// what blocked the Connections page (ORP-18698) from being buildable at parity.
//
// Keys are snake_case because that is what `normalizePlatformLogoKey` produces; the extra entries
// beside a canonical key are older spellings other surfaces (reports, health checks) still pass.
const STATIC_PLATFORM_LOGOS: Readonly<Record<string, string>> = {
  adapty,
  adjust,
  akakce,
  apple: appleSearchAds,
  appstore: appStore,
  app_store: appStore,
  apple_search_ads: appleSearchAds,
  applesearchads: appleSearchAds,
  applovin_max: applovinMax,
  app_samurai: appSamurai,
  appsamurai: appSamurai,
  appsflyer,
  bigquery,
  bing: bingAds,
  bing_ads: bingAds,
  cm360,
  cimri,
  criteo,
  display_video_360: dv360,
  dv360,
  facebook: metaAds,
  ga4: googleAnalytics,
  gelir_ortaklari: gelirOrtaklari,
  google: googleAds,
  google_ads: googleAds,
  googleads: googleAds,
  google_analytics: googleAnalytics,
  google_search_console: googleSearchConsole,
  search_console: googleSearchConsole,
  google_sheets: googleSheets,
  hardal,
  ikas,
  instagram: metaAds,
  windows: microsoftStore,
  microsoft_store: microsoftStore,
  linkedin,
  linkedin_ads: linkedin,
  merchant_center: merchantCenter,
  meta: metaAds,
  meta_ads: metaAds,
  metaads: metaAds,
  openai_ads: openaiAds,
  pinterest,
  google_play: playStore,
  play_store: playStore,
  reddit,
  reklamstore,
  revenuecat,
  rtb: rtbHouse,
  hopi: hopi,
  rtb_house: rtbHouse,
  shopify,
  singular,
  snapchat: snapchatAds,
  snapchat_ads: snapchatAds,
  gtm: tagManager,
  gtm_container: tagManager,
  tag_manager: tagManager,
  ticimax,
  tiktok: tiktokAds,
  tiktok_ads: tiktokAds,
  tiktokads: tiktokAds,
  tsoft,
  twitter,
  yandex,
  yango,
  youtube,
}

export function normalizePlatformLogoKey(value: unknown): string {
  return typeof value === 'string'
    ? value
        .trim()
        .toLowerCase()
        .replaceAll(/[-\s]+/gu, '_')
    : ''
}

/** Static, store-free logo lookup shared by feature surfaces such as reports and Health Checks. */
export function resolveStaticPlatformLogo(value: unknown): string | undefined {
  const key = normalizePlatformLogoKey(value)
  if (!key) return undefined
  const direct = STATIC_PLATFORM_LOGOS[key]
  if (direct) return direct

  for (const candidate of Object.keys(STATIC_PLATFORM_LOGOS).sort(
    (left, right) => right.length - left.length,
  )) {
    if (key.includes(candidate)) return STATIC_PLATFORM_LOGOS[candidate]
  }
  return undefined
}
